import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckoutDialog } from "@/components/CheckoutDialog";
import { SlideCarousel } from "@/components/SlideCarousel";
import { WishSlide } from "@/components/WishSlide";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { FavoriteMaestrosList } from "@/components/FavoriteMaestrosList";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Heart, Loader2, Star } from "lucide-react";

export default function SavedReservations() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [payItem, setPayItem] = useState(null);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "maestros" ? "maestros" : "talleres";

  const load = () => api.get("/saved").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { if (user) load(); }, [user]);

  const remove = async (id) => {
    try { await api.delete(`/saved/${id}`); toast.success("Eliminado de Mi Lista de Deseos"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  const pay = (item) => { setPayItem(item); setCheckoutOpen(true); };

  if (user === false) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-16 text-center">
        <Heart className="w-10 h-10 mx-auto text-coral mb-3" />
        <h1 className="text-2xl font-extrabold">Mi Lista de Deseos</h1>
        <p className="text-muted-foreground mt-2">Inicia sesión para ver los talleres y Maestros que guardaste.</p>
        <Link to="/login"><Button className="mt-5" data-testid="saved-login-btn">Iniciar sesión</Button></Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl font-extrabold tracking-tight flex items-center gap-2">
        <Heart className="w-7 h-7 text-coral fill-coral/20" /> Mi Lista de Deseos
      </h1>
      <Tabs value={tab} onValueChange={(v) => setParams(v === "maestros" ? { tab: "maestros" } : {}, { replace: true })} className="mt-6">
        <TabsList className="grid grid-cols-2 w-full sm:w-auto sm:inline-grid" data-testid="wishlist-tabs">
          <TabsTrigger value="talleres" className="gap-1.5" data-testid="wishlist-tab-talleres"><Heart className="w-4 h-4" />Talleres</TabsTrigger>
          <TabsTrigger value="maestros" className="gap-1.5" data-testid="wishlist-tab-maestros"><Star className="w-4 h-4" />Maestros favoritos</TabsTrigger>
        </TabsList>
        <TabsContent value="maestros" className="mt-6">{user && <FavoriteMaestrosList />}</TabsContent>
        <TabsContent value="talleres">
      <p className="text-muted-foreground mt-4">Los talleres que quieres hacer, para que no se te olviden. Desliza para ver cada deseo. Tu cupo se confirma al presionar “Reservar”.</p>

      {items === null ? (
        <div className="py-16 grid place-items-center text-muted-foreground"><Loader2 className="w-6 h-6 animate-spin" /></div>
      ) : items.length === 0 ? (
        <div className="mt-8 text-center py-16 text-muted-foreground" data-testid="saved-empty">
          <Heart className="w-10 h-10 mx-auto mb-3 opacity-40" />
          Aún no tienes talleres en tu lista. Explora el catálogo y pulsa “Agregar a Mi Lista de Deseos”.
          <div><Button asChild variant="link"><Link to="/explorar">Explorar talleres</Link></Button></div>
        </div>
      ) : (
        <div className="mt-8" data-testid="saved-list">
          <SlideCarousel items={items} prefix="saved" label="Deseo"
            render={(it) => <WishSlide it={it} onPay={pay} onRemove={remove} />} />
        </div>
      )}
        </TabsContent>
      </Tabs>

      {payItem && (
        <CheckoutDialog open={checkoutOpen} onOpenChange={setCheckoutOpen}
          workshop={payItem.workshop} />
      )}
    </div>
  );
}
